var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.FadeTransition,[(_setup.showNavbar)?_c(_setup.NavBar,{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c(_setup.BackButton,{on:{"click":_setup.backStep}})]},proxy:true}],null,false,1973545780)}):_vm._e()],1),_c(_setup.FadeTransition,[_c(_setup.step.component,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }